exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-cb51a9aa]:export{menu-bgc-oragne:#F2C46D}.spwwIndexPage[data-v-cb51a9aa]{display:flex;flex-direction:column;height:100%;overflow-y:scroll}.spwwIndexPage[data-v-cb51a9aa]::-webkit-scrollbar{display:none}\n", ""]);

// exports
